module.exports = __webpack_public_path__ + "img/feedback_and_coaching.77f5aa5a.svg";